import { Injectable, OnDestroy, inject } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { Store } from '@ngrx/store';
import { AuthenticationType } from '../models/authentication-type.enum';
import { IAuthService } from '../models/iauth-service.model';
import { MsalAuthBaseService } from './msal-auth-base.service';

@Injectable()
export class AzureADAuthService extends MsalAuthBaseService implements IAuthService, OnDestroy {
  constructor() {
    const _msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
    const _broadcastService = inject(MsalBroadcastService);
    const _msalService = inject(MsalService);
    const _store = inject(Store);

    super(_msalGuardConfig, _broadcastService, _msalService, _store);
  }

  getAuthenticationType(): AuthenticationType {
    return AuthenticationType.AzureActiveDirectory;
  }
}
